import React, { useRef, useEffect } from 'react';
import { useScript } from 'usehooks-ts';
import PT from 'prop-types';

export const JsonEditorView = props => {
    const { name, value, onChange } = props;
    const editorRef = useRef(null);

    const status = useScript(`https://cdnjs.cloudflare.com/ajax/libs/ace/1.27.0/ace.min.js`, {
        removeOnUnmount: false,
    });

    const handleEditorOnChange = (editor) => {
        const editorValue = editor.getSession().getValue();
        onChange(editorValue);
    };

    useEffect(() => {
        if(status == "ready" && editorRef.current){
            const editor = window.ace.edit(editorRef.current,{
                mode: "ace/mode/json",
                theme: "ace/theme/gihub"
            });
            editor.setValue(value);
            editor.getSession().on("change", () => handleEditorOnChange(editor));
        }
    }, [status, editorRef.current]);


    const style = {
        width: '1000px',
        height: '50vh'
    };

    return (
        <div style={style} ref={editorRef} id={name}></div>
    );
};

JsonEditorView.propTypes = {
    name: PT.string,
    value: PT.string,
    onChange: PT.func,
    height: PT.string,
    readOnly: PT.bool
};

JsonEditorView.defaultProps = {
    readOnly: false
};